import { Transform, TransformFnParams, TransformOptions } from 'class-transformer';
import { parseAndFormatToStartOfLocalDate } from '@core/util';
import { isValid } from 'date-fns';

/**
 * Transform a date string or Date object to a Local Date string.
 * @param dateFormat - The format to parse the date string.
 * @param options - Optional transform options.
 */
export function ToStartOfLocalDateString(dateFormat: string, options?: TransformOptions) {
  return Transform((params: TransformFnParams) => {
    const value = params.obj[params.key];
    const date = parseAndFormatToStartOfLocalDate(value, { format: dateFormat });

    return date?.format || value;
  }, options);
}

export function ClonedIsoString(originalKey: string) {
  return Transform(({ obj }) => {
    const value = obj[originalKey];

    if (!value) return value;

    if (value instanceof Date) return value.toISOString();

    if (typeof value === 'string') {
      // 2025-06-30 -> 2025-06-30T00:00:00.000Z
      // const date = new Date(value);
      // if (isValid(date) && !isNaN(date.getTime())) return date.toISOString();

      // 2025-06-30 -> 2025-06-29T17:00:00.000Z
      const dateParts = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      const date = dateParts
        ? new Date(parseInt(dateParts[1]), parseInt(dateParts[2]) - 1, parseInt(dateParts[3]))
        : new Date(value);

      if (isValid(date) && !isNaN(date.getTime())) return date.toISOString();
    }

    return value;
  });
}
